import { Injectable } from "@angular/core";

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  // { state:'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer' },
  // { state: "dashboard", name: "Dashboard", type: "link", icon: "av_timer", iconUrl: "assets/images/dashboard.png" },
  // { state: "user-management", type: "link", name: "Users", icon: "people_alt", iconUrl: "assets/images/users.png" },
  // {
  //   state: "vedio-management",
  //   type: "link",
  //   name: "Analytics",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/font.png"
  // },
  // { state: "school-management", type: "link", name: "School", icon: "people_alt", iconUrl: "assets/images/open-book.png" },
  // {
  //   state: "company-management",
  //   type: "link",
  //   name: "Company",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/office.png"
  // },
  // {
  //   state: "general-management/genre",
  //   type: "link",
  //   name: "Genre",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/dj.png"
  // },
  // {
  //   state: "general-management/style",
  //   type: "link",
  //   name: "Style",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/font.png"
  // },
  // {
  //   state: "general-management/music",
  //   type: "link",
  //   name: "Music",
  //   icon: "library_music",
  //   iconUrl: "assets/images/musical-note.png"
  // },
  // {
  //   state: "general-management/composer",
  //   type: "link",
  //   name: "Composer",
  //   icon: "mic",
  //   iconUrl: "assets/images/karaoke.png"
  // },
  // {
  //   state: "general-management/choreographer",
  //   type: "link",
  //   name: "Choreographer",
  //   icon: "music_video",
  //   iconUrl: "assets/images/music-composition.png"
  // },
  // {
  //   state: "general-management/dancer",
  //   type: "link",
  //   name: "Dancer",
  //   icon: "queue_music",
  //   iconUrl: "assets/images/man-dancing-.png"
  // },
  // {
  //   state: "general-management/venue",
  //   type: "link",
  //   name: "Venue",
  //   icon: "repeat",
  //   iconUrl: "assets/images/musical-note.png"
  // },
  // {
  //   state: "general-management/hashtag",
  //   type: "link",
  //   name: "Hashtag",
  //   icon: "playlist_play",
  //   iconUrl: "assets/images/music.png"
  // },
  // {
  //   state: "general-management/songs",
  //   type: "link",
  //   name: "Songs",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/playlist (3).png"
  // },
  // {
  //   state: "add-company",
  //   type: "link",
  //   name: "Company User",
  //   icon: "people_alt",
  //   iconUrl: "assets/images/com.png"
  // },

  // { state: 'rules-management', type: 'link', name: 'Rules', icon: 'people_alt',iconUrl:'assets/images/rules.png' },
  // { state: 'race-management', type: 'link', name: 'Races', icon: 'people_alt',iconUrl:'assets/images/race.png' },
  // { state: 'participant-management', type: 'link', name: 'Participants', icon: 'people_alt',iconUrl:'assets/images/people.png' },
  {
    state: "setting",
    type: "link",
    name: "Settings",
    icon: "settings",
    iconColor: "rgba(0, 0, 0, 0.87)",
    iconUrl: "assets/images/settings (3).png"
  }
  // { state: 'snackbar', type: 'link', name: 'Snackbar', icon: 'adb' },
  // { state: 'slider', type: 'link', name: 'Slider', icon: 'developer_mode' },
  // {
  //   state: 'slide-toggle',
  //   type: 'link',
  //   name: 'Slide Toggle',
  //   icon: 'all_inclusive'
  // }
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
